import React, { useState, useReducer, useEffect } from 'react';
import {
  Paper,
  Chip,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
  Tooltip,
} from '@mui/material';
import {
  Link as RouterLink,
} from 'react-router-dom';
import {
  Column,
  FilteringState, GroupingState,
  IntegratedFiltering, IntegratedGrouping, IntegratedPaging, IntegratedSelection, IntegratedSorting,
  PagingState, SelectionState, SortingState, DataTypeProvider, DataTypeProviderProps, VirtualTableState, TableColumnResizing, 
} from '@devexpress/dx-react-grid';
import {
  DragDropProvider,
  Grid, GroupingPanel, PagingPanel,
  Table, TableFilterRow, TableGroupRow,
  TableHeaderRow, TableSelection, Toolbar, VirtualTable,
  TableColumnReordering
} from '@devexpress/dx-react-grid-material-ui';
import TimeAgo from 'react-timeago'

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';

// ************************************************************
// ************************************************************
// ************************************************************

const VIRTUAL_PAGE_SIZE = 50;
const getRowId = row => row.id;

// ************************************************************
// ************************************************************
// ************************************************************

const RowNumFormatter = ({ value }) => {
  return (
    <>
      <Chip label={value} size="small" variant="outlined" /> 
    </>
  )
}
const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

const EcuIdFormatter = ({ row }) => {
  return (
    <> 
      <Chip 
        label={row.id} 
        color="primary" 
        clickable
        />      
    </>
  )
} 

// ************************************************************
// ************************************************************
// ************************************************************

const Cell = (props) => {
  const { column } = props;
  // if (column.name === 'discount') {
  //   return <ProgressBarCell {...props} />;
  // }
  // if (column.name === 'amount') {
  //   return <HighlightedCell {...props} />;
  // }
  return <VirtualTable.Cell {...props} />;
};
const Root = props => <Grid.Root {...props} style={{ height: '100%' }} />;

export default class ErrorCodeList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tableRows: [],
      tableTotalRowCount: 0,
      tableLoading: true,
      tableColumns: this.getTableColumns(),
      tableColumnExtensions: this.getTableColumnExtensions(),
      sortingStateColumnExtensions: this.getSortingStateColumnExtensions(),
    }
  }
  getSortingStateColumnExtensions() {
    return [
      { columnName: 'eng', sortingEnabled: false },
      { columnName: 'ita', sortingEnabled: false },
      { columnName: 'esp', sortingEnabled: false },
    ]
  }
  getTableColumnExtensions() {
    return [
      { columnName: 'id', width: 120 },
    ]
  }
  getTableColumns() {
    return [
      { name: 'type', title: 'TYPE',      getCellValue: row => row.type },
      { name: 'id',   title: 'DTC Code',  getCellValue: row => row.id   },
      { name: 'eng',  title: 'English',   getCellValue: row => row.eng  },
      { name: 'ita',  title: 'Italiano',  getCellValue: row => row.ita  },
      { name: 'esp',  title: 'Español',   getCellValue: row => row.esp  },
    ]
  }  
  async componentDidMount() {
    var lang = await AuthService.getLang()
    ///console.log(lang.DTC)    
    lang.DTC.map(item => {
      if (item.id.startsWith("P")) 
        item.type = "Powertrain Code"
      else if (item.id.startsWith("B")) 
        item.type = "Body Code"
      else if (item.id.startsWith("U")) 
        item.type = "Network Code"
      else if (item.id.startsWith("C")) 
        item.type = "Chassis Code"
      return item
    })
    //console.log(lang.DTC)
    this.setState({
      tableRows: lang.DTC,
      tableTotalRowCount: lang.DTC.length,
      tableLoading: false,
    })    
  }
  render() {     
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    //if (!utils.userHasRoleAdmin(this.props.authStatus.user)) return <UserAuthRequired notallowed />

    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper style={{ height: height }}>
        <Grid 
          rows={this.state.tableRows}
          columns={this.state.tableColumns}
          getRowId={getRowId}
          rootComponent={Root}
          >        
          <FilteringState
            defaultFilters={[]}
            />
          <SortingState
            defaultSorting={[
              { columnName: 'type', direction: 'asc' },
              { columnName: 'id', direction: 'asc' },
            ]}
            columnExtensions={this.state.sortingStateColumnExtensions}
            />

          <GroupingState
            defaultGrouping={[{ columnName: 'type' }]}
            defaultExpandedGroups={['Powertrain Code']}
            />
          
          <IntegratedGrouping />
          <IntegratedFiltering />
          <IntegratedSorting />

          <VirtualTable
             //height={height}
            columnExtensions={this.state.tableColumnExtensions}
            // cellComponent={Cell}
            height="auto"
          />
          
          <DragDropProvider />
          {/* 
          <Table 
            height={height}
            columnExtensions={this.state.tableColumnExtensions}
            />  
          <PagingState />
          <IntegratedPaging />
          <PagingPanel pageSizes={[10]} />
          */}

          <TableColumnReordering
            defaultOrder={['type', 'id', 'eng', 'ita', 'esp']}
            />        
          <FilteringState
            defaultFilters={[]}
            />    
          <TableHeaderRow showSortingControls={true} />
          <TableFilterRow showFilterSelector={true} />
          
          <TableGroupRow />
          {/* <Toolbar /> */}
          {/* <GroupingPanel showSortingControls={true} /> */}

        </Grid>
      </Paper>
    )
  }
}
